<template>
    <ThTitle
        :alignment="data.alignment"
        :color="thColor"
        :size="data.titleSize"
        :tag="data.tag"
        :title-style="data.titleStyle"
        :width="data.titleWidth"
        class="content-title"
    >
        <template v-for="(text, index) in data.texts">
            <template v-if="text.__typename === 'ComponentTitleText'">
                {{ text.text }}
            </template>

            <span
                v-else-if="text.__typename === 'ComponentTitleAmpersand'"
                :key="index"
                class="th-ampersand"
            >
                &amp;
            </span>
        </template>
    </ThTitle>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { Color, ComponentTitleFragment } from '@/graphql/api'
import { cmsColorToButtonColor } from '@/components/cms'
import type { Colors } from '@/components/ui'

import ThTitle from '@/components/ui/title/ThTitle.vue'

const props = defineProps<{
    data: ComponentTitleFragment
    background?: Color
}>()

const thColor = computed(
    (): Colors | undefined =>
        props.data.color && cmsColorToButtonColor(props.data.color)
)
</script>
